/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 11:09:24
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/DiscountMethod/index.tsx
 */
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Item = Form.Item;

export enum EMethod {
  Percentage = 'Percentage',
  Reduction = 'Reduction',
  Gift = 'Gift',
  Shipping = 'Shipping',
}
const _base = 'discountMethod';
const type = [_base, 'discountType'];

const Method = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disableEdit } = props;
  return (
    <SectionWrapper
      containerClassName={`${css.sectionContainer} ${css.sectionContainerWeights}`}
      title={getI18n('general.type')}>
      <Item
        name={type}
        rules={[{ required: true, message: 'Please select a value' }]}>
        <RadioGroup className={css.radioGroup} disabled={disableEdit}>
          <RadioItem className={css.radio} value={EMethod.Percentage}>
            {getI18n('general.percentageOff')}
          </RadioItem>
          <RadioItem className={css.radio} value={EMethod.Reduction}>
            {getI18n('salesChannelDirectDiscount.type.fixedReductionAmount')}
          </RadioItem>
          <RadioItem className={css.radio} value={EMethod.Gift}>
            {getI18n('salesChannelDirectDiscount.type.buyOneGetOneFree')}
          </RadioItem>
          <RadioItem value={EMethod.Shipping}>
            {getI18n('salesChannelDirectDiscount.type.shippingDiscount')}
          </RadioItem>
        </RadioGroup>
      </Item>
    </SectionWrapper>
  );
};
export default Method;
